module.exports = __webpack_public_path__ + "img/kommune-2020.3fcf4f1d.svg";